import React from 'react';
import './CommitteeSection.css';

/**
 * Reusable section for displaying a list of committee members.
 *
 * Props:
 *  - heading: string – section title, eg. "Organising Committee"
 *  - badgeLabel: string (optional) – small label above heading
 *  - members: array of { name, institution } objects
 */
const CommitteeSection = ({ heading, badgeLabel, members }) => {
  const hasData = Array.isArray(members) && members.length > 0;

  return (
  <section className={`committee-section fade-in-up`}>
    <div className="container-small">
      {badgeLabel && <span className="badge committee-badge">{badgeLabel}</span>}
      {heading && <h2 className="committee-heading">{heading}</h2>}

      {hasData ? (
        <div className="committee-table-wrapper">
          {members.map(({ name, institution }, i) => (
            <div
              key={name}
              className={`committee-row ${i % 2 === 0 ? 'alt' : ''} animate`}
            style={{ animationDelay: `${i * 60}ms` }}>

              <p className="committee-row-name">{name}</p>
              <p className="committee-row-inst">{institution}</p>
            </div>
          ))}
        </div>
      ) : (
        <p className="committee-loading">Loading...</p>
      )}
    </div>
  </section>
);
};

export default CommitteeSection;
